<template>
  <v-container
    v-if="recinto"
    fluid
  >
    <v-img
      height="100%"
      class="fondo-recinto"
      :src="urlPlaces('banner')"
      gradient="to top left, rgba(255,255,255,.1), rgba(255,255,255,.3)"
    >
      <v-layout
        align-center
        fill-height
        column
      >

        <v-container
          class="ma-5 transparent contenedor-recinto"
          grid-list-md
          text-xs-center
        >
          <v-layout
            row
            wrap
          >
            <v-flex xs12>
              <v-card
                flat
                color="transparent"
              >
                <h1 class="headline sombra text-sm-left white--text mb-0">{{getInfo('nombre')}}</h1>
                <p class="subheading text-sm-left white--text mb-5">Explora los eventos de {{getInfo('nombre')}} </p>

              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card
                flat
                color="grey lighten-3"
              >
                <v-container
                  fluid
                  grid-list-xs
                  class="pa-0"
                >
                  <v-layout
                    row
                    wrap
                  >
                    <v-flex
                      xs12
                      class="pb-0"
                    >
                      <v-card
                        color="grey lighten-3"
                        class="white--text"
                      >
                        <v-layout row>
                          <v-flex
                            xs8
                            class="py-0"
                          >
                            <v-img
                              :src="urlPlaces('fondo')"
                              aspect-ratio="2.6"
                            ></v-img>
                          </v-flex>
                          <v-flex xs4>
                            <v-card
                              flat
                              color="grey lighten-3"
                              class="subheading font-weight-bold fill-height text-xs-left grey--text"
                            >
                              <v-card-text v-html="getInfo('direccion')">
                              </v-card-text>
                              <v-card-text v-text="getInfo('poblacion')">

                              </v-card-text>
                              <v-card-text class="abajo">
                                <v-btn
                                  :to="`/${$i18n.locale}/ver-recinto/${idRecinto}`"
                                  
                                  block
                                  :color="colorDestacado"
                                  dark
                                >Ver Eventos</v-btn>
                              </v-card-text>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>
            <v-flex
              xs12
              class="mt-0 text-xs-left grey--text"
            >
              <v-card
                dark
                color="white"
                class="black--text text-none"
              >
                <v-layout row>
                  <v-flex xs8>
                    <v-container>
                      <v-card-title
                        class="headline font-weight-bold"
                        v-text="getInfo('nombre')"
                      >

                      </v-card-title>
                      <v-card-text class="title">
                        Acerca de este recinto
                      </v-card-text>
                      <v-card-text v-html="getInfo('detalle')">

                      </v-card-text>
                    </v-container>
                  </v-flex>
                  <v-flex xs4>
                    <v-card
                      flat
                      color="white"
                      class="headline fill-height text-xs-left black--text"
                      v-if="recinto"
                    >
                      <v-container>
                        <v-card-title class="title font-weight-bold">
                          Cómo llegar
                        </v-card-title>
                        <v-list
                          light
                          two-line
                          class="sin-margen"
                        >
                          <v-list-tile
                            avatar
                            @click="getUrl('parking')"
                          >
                            <v-list-tile-avatar>
                              <i
                                class="fa fa-car fa-2x"
                                aria-hidden="true"
                              ></i>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title v-html="getInfo('parking')"></v-list-tile-title>
                              <v-list-tile-sub-title>
                                <a
                                  :href="getUrl('parking')"
                                  target="_blank"
                                >Ver en Mapa</a>
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile
                            avatar
                            @click="getUrl('bus')"
                          >
                            <v-list-tile-avatar>
                              <i
                                class="fa fa-bus fa-2x"
                                aria-hidden="true"
                              ></i>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title v-html="getInfo('bus')"></v-list-tile-title>
                              <v-list-tile-sub-title><a
                                  :href="getUrl('bus')"
                                  target="_blank"
                                >Ver en Mapa</a> </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile
                            avatar
                            @click="getUrl('metro')"
                          >
                            <v-list-tile-avatar>
                              <i
                                class="fa fa-subway fa-2x"
                                aria-hidden="true"
                              ></i>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title v-html="getInfo('metro')"></v-list-tile-title>
                              <v-list-tile-sub-title>
                                <a
                                  :href="getUrl('metro')"
                                  target="_blank"
                                >Ver en Mapa</a>
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </v-container>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex
              xs12
              v-if="verMapa"
            >
              <v-card
                dark
                color="white"
                v-if="ubicacion"
                height="300px"
              >

                <googlemaps-map
                  ref="map"
                  class="map"
                  :center.sync="ubicacion"
                  :zoom.sync="zoom"
                  :options="mapOptions"
                >
                  <v-layout
                    slot="placeholder"
                    fill-height
                    align-center
                    justify-center
                    ma-0
                  >
                    <v-progress-circular
                      indeterminate
                      :color="colorDestacado"
                    ></v-progress-circular>
                  </v-layout>

                  <googlemaps-marker
                    :title="recintoPlace.formatted_address"
                    :position="ubicacion"
                  />

                </googlemaps-map>
              </v-card>
            </v-flex>
            <v-flex
              v-for="i in 6"
              :key="`2${i}`"
              xs2
            >
              <v-card
                dark
                color="primary"
              >
                <v-card-text class="px-0">2</v-card-text>
              </v-card>
            </v-flex>
            <v-flex
              v-for="i in 12"
              :key="`1${i}`"
              xs1
            >
              <v-card
                dark
                color="secondary"
              >
                <v-card-text class="px-0">1</v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <!-- <h1 class="display-2 white--text font-weight-thin mb-3">Vuetify.js</h1>
      <v-card color="transparent">
        <v-container>
          <v-layout row wrap>
            
          </v-layout>
      

        </v-container>
      </v-card> -->

      </v-layout>
    </v-img>
    <a
      :href="url"
      target="_blank"
    >{{idRecinto}}</a>
    <br>
    <a
      v-if="urlEspacio"
      :href="urlEspacio"
      target="_blank"
    >Info del espacio</a>
    <h3>Recinto</h3>
    <pre>
      {{ubicacion}}
      LLL
      {{recinto}}
    </pre>
    <h3>Recinto info</h3>
    <pre>
      {{recintoInfo}}
    </pre>
    <h3>Espacio Info</h3>
    <pre>
      {{espacioInfo}}
    </pre>

  </v-container>
</template>
<style>
.v-card a {
  text-decoration: none;
}
.fondo-recinto > .v-image__image.v-image__image--cover {
  filter: blur(10px);
}
.contenedor-recinto {
  margin-top: 40px;
}
.sombra {
  text-shadow: 2px 2px #444;
}
.abajo {
  position: absolute;
  bottom: 0;
}
.sin-margen .v-list__tile {
  padding: 0;
}
.map {
  height: 300px;
  width: 100%;
}
</style>

<script>
//getLayout
import { globales } from "../../components/comunes";
import FireStoreParser from "firestore-parser";
import axios from "axios";

export default {
  mixins: [globales],
  props: ["idRecinto"],

  created() {
    const idRecinto = this.idRecinto;
    this.$store.commit("setCargando", true);
    this.scrollTop();

    const url =
      "https://firestore.googleapis.com/v1beta1/projects/jmdb-production/databases/(default)/documents/recintos/" +
      idRecinto;
    const urlEspacio =
      "https://firestore.googleapis.com/v1beta1/projects/jmdb-production/databases/(default)/documents/espacios/";

    console.log("Buscar Recinto", url);
    this.url = url + "/info/cms";
    const self = this;
    axios
      .get(url)
      .then(res => {
        console.log("resultado", res);
        this.$store.commit("setCargando", false);
        if (res.hasOwnProperty("data")) {
          if (res.data.fields.hasOwnProperty("places")) {
            delete res.data.fields.places.arrayValue.values[0].mapValue.fields
              .html_attributions;
            console.log("tiene places", res.data.fields, this);
          }
          const resultado = FireStoreParser(res.data);

          if (resultado.fields.hasOwnProperty("place_id")) {
            console.log("resultado", resultado);
            self.urlEspacio =
              urlEspacio + resultado.fields.place_id + "/info/cms";
            self.urlRecinto = url + "/info/cms";
            self.recintoInfo = self.getData(self.urlRecinto, "recintoInfo");
            self.espacioInfo = self.getData(self.urlEspacio, "espacioInfo");
          }

          return resultado;
        }
      })
      .then(json => {
        console.log("axios", json.fields);
        this.recinto = json.fields;
        // this.$store.dispatch("getLayout", recintoData);
      })
      .catch(err => {
        this.$store.commit("setCargando", false);
        console.log(err);
      });
  },
  data() {
    return {
      recintoInfo: {},
      url: null,
      urlEspacio: null,
      espacioInfo: {},
      recinto: {},
      zoom: 18,
      miUbicacion: null,
      verEnMapa: false,
    };
  },
  computed: {
    recintoPlace() {
      const place = this.recinto ? this.recinto.places[0] : {};

      return place;
    },
    mapOptions() {
      return {
        clickableIcons: false,
        draggable: false,
        disableDefaultUI: true,
        keyboardShortcuts: false,
        disableDoubleClickZoom: true,
      };
    },
    verMapa() {
      const ver = this.recinto.places ? true : false;

      return ver;
    },
    ubicacion() {
      let respuesta = null;
      if (this.recinto) {
        if (this.recinto.hasOwnProperty("places")) {
          const valor = this.recinto.places[0].geometry.location;
          console.log("valor", valor);
          const resultado = {};
          const calculo = Object.keys(valor).forEach(
            e => (resultado[e] = valor[e].doubleValue)
          );

          respuesta = resultado;
        }
      }
      return respuesta;
    },
  },
  methods: {
    scrollTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    getData(url, fuente) {
      this.$store.commit("setCargando", true);
      axios
        .get(url)
        .then(res => {
          console.log("XXXXXX", res);
          this.$store.commit("setCargando", false);
          if (res.hasOwnProperty("data")) {
            if (res.data.fields.hasOwnProperty("places")) {
              delete res.data.fields.places.arrayValue.values[0].mapValue.fields
                .html_attributions;
              // console.log('tiene places', res.data.fields, this)
            }
            const resultado = FireStoreParser(res.data);

            // if (resultado.fields.hasOwnProperty('place_id')) {
            //   console.log('resultado', resultado)
            //   self.urlEspacio = urlEspacio + resultado.fields.place_id + '/info/cms'

            // }

            return resultado;
          } else {
            console.log("NANDA", url);
            return {};
          }
        })
        .then(json => {
          console.log("YYYYYYYY", "fuente", fuente, json.fields);
          // this.recintoInfo = json.fields
          this[fuente] = json.fields;
          return json.fields;
          // this.$store.dispatch("getLayout", recintoData);
        })
        .catch(err => {
          this.$store.commit("setCargando", false);
          console.log(err);
        });
    },
    getInfo(info) {
      var valor = null;
      if (info === "nombre") {
        valor = this.recinto.Nombre
          ? this.recinto.Nombre
          : this.recinto.nombre
            ? this.recinto.nombre
            : null;
      } else if (info === "direccion") {
        valor = this.recinto.Direccion
          ? this.recinto.Direccion
          : this.recinto.direccion
            ? this.recinto.direccion
            : null;
      } else if (info === "poblacion") {
        valor = this.recinto.Poblacion
          ? this.recinto.Poblacion.Nombre
          : this.recinto.poblacion
            ? this.recinto.poblacion
            : null;
      } else if (info === "detalle") {
        valor = this.recintoInfo.detalle
          ? this.recintoInfo.detalle
          : this.espacioInfo.detalle
            ? this.espacioInfo.detalle
            : null;
      } else if (info === "parking") {
        valor = this.recintoInfo.parking
          ? this.recintoInfo.parking
          : this.espacioInfo.parking
            ? this.espacioInfo.parking
            : null;
      } else if (info === "bus") {
        valor = this.recintoInfo.bus
          ? this.recintoInfo.bus
          : this.espacioInfo.bus
            ? this.espacioInfo.bus
            : null;
      } else if (info === "metro") {
        valor = this.recintoInfo.metro
          ? this.recintoInfo.metro
          : this.espacioInfo.metro
            ? this.espacioInfo.metro
            : null;
      }

      return valor;
    },
    getUrl(url) {
      var miUbicacion = this.miUbicacion;
      var recinto = this.ubicacion;
      var verEnMapa = this.verEnMapa;

      var geoSuccess = function(position) {
        miUbicacion = position.coords;

        var link = `https://www.google.com/maps/dir/?api=1&origin=${
          miUbicacion.latitude
        },${miUbicacion.longitude}&destination=${recinto.lat},${recinto.lng}`;
        console.log("miUbicacion", miUbicacion, recinto, link);

        if (verEnMapa) {
          window.open(link, "_blank");
        }
      };
      var geoError = function(error) {
        console.log("Error occurred. Error code: " + error.code);
        // error.code can be:
        //   0: unknown error
        //   1: permission denied
        //   2: position unavailable (error response from location provider)
        //   3: timed out
      };
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(geoSuccess, geoError);
      } else {
        console.log("Geolocation is not supported for this Browser/OS.");
      }
      console.log("Url", url, "ubicacion", this.miUbicacion);
    },
    urlPlaces() {
      const sinImagen = this.sinImagen;
      if (this.recintoInfo.hasOwnProperty("imageUrl")) {
        return this.recintoInfo.imageUrl;
      } else {
        return sinImagen;
      }
    },
  },
};
</script>
